module.exports = __webpack_public_path__ + "img/ico_federazione.3d2361bb.png";